import React, {useContext} from 'react';
import GettingStartedContext from "../utils/GettingStartedContext";

const StartOverButton = ({startOver, exist, text}) => {

  const {
    data,
    setShowSkip,
    setShowResult,
    setQuestion
  } = useContext(GettingStartedContext)

  const restart = () => {
    if (startOver) {
      setShowSkip(false);
      setShowResult(false);
      setQuestion(data.Questions[0]);
    } else {
      const returnLink = document.getElementById('root').getAttribute('data-returnlink');
      window.location.href = returnLink;
    }
  }

  return <li onClick={restart}>
    <a>
      <img src="_resources/themes/airsprint/images/gsa/exit-icon.svg" className="exit-icon" />
      {text}
    </a>
  </li>

}

export default StartOverButton;
